<template>
  <div class="header">
    <b-navbar class="header" toggleable="lg">
      <div class="container">
        <router-link class="lien_image" :to="{name:'Home'}">
          <img alt="logo" src="../assets/metzexpress.png" width="225px"/>
        </router-link>

        <a class="lien_image" target="_blank" href="https://www.fluo.eu/">
          <img alt="logo" src="../assets/fluo.png" width="225px"/>
        </a>
      </div>
    </b-navbar>
  </div>
</template>

<script>
  export default {
    name: 'Header'
  }
</script>

<style lang="scss">
@import "../sass/app";

.header {
  .lien_image {
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue